{
	"title": "Kommentarer",
	"statuses": {
		"inValidation": "Under validering",
		"rejected": "Avvist",
		"assured": "Sikret",
		"flagged": "Flagget",
		"resolved": "Løst"
	}
}
